import { get, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { StopOutlined } from "@ant-design/icons";
import { setSection } from "../../../redux/ducks/Section";
import { useTranslation } from "react-i18next";
import { Tabs } from "antd";
import "./SalDeclaration.css";
import Detail from "./Detail";
import { useSelector } from "react-redux";
import WorkMonth from "./WorkMonth";
import { setLoading } from "../../../redux/ducks/Loading";
import OrderProposal from "../../../services/api/OrderProposal";
import { showError } from "../../../utils/utilities";
import { setOrder } from "../../../redux/ducks/Orders";
import dayjs from "dayjs";

const SalDeclarationTabs = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const order = useSelector((state) => get(state.OrdersDuck, "order", {}));
  const { t } = useTranslation();
  const [state, setState] = useState({
    dataContent: {},
    supportPm: [],
    error: false,
  });
  useEffect(() => {
    if (isEmpty(state.dataContent) && !state.error) {
      dataGet();
    } else if (!state.error) {
      dispatch(
        setSection({
          section: {
            title: `ODA ${state.dataContent.id}`,
          },
        })
      );
    }
  }, [id, state.dataContent]);
  const dataGet = async () => {
    dispatch(setLoading(true));
    const order = await OrderProposal.getOrder(id);
    if (!order.error) {
      dispatch(setOrder(get(order, "data", {})));
      setState((prevState) => ({
        ...prevState,
        dataContent: get(order, "data", {}),
      }));
    } else {
      showError(get(order, "error.messageCode", "ER000"));
      setState((prevState) => ({ ...prevState, error: true }));
    }
    dispatch(setLoading(false));
  };

  return (
    <Tabs
      className="PFtabs"
      defaultActiveKey="1"
      items={[
        {
          label: `ODA ${state.dataContent.id}`,
          key: "1",
          children: <Detail />,
        },
        {
          label: (
            <div>
              {order.statusOrder === "BLOCKED" && <StopOutlined className="PFred mr-10" />}
              {`${t("salDeclaration.detail.workMonth")} ${dayjs(order.month && order.month.toString(), "YYYYMM").format(
                "MM/YYYY"
              )}`}
            </div>
          ),
          key: "2",
          children: <WorkMonth />,
        },
      ]}
    />
  );
};

export default SalDeclarationTabs;
